export default "__VITE_ASSET__CueIV$6u__"